export default "__VITE_ASSET__DwnDBnhP__"